export const buildStudentLabel = (item, items) => {
  const fullName = item.username
    ? item.username
    : item?.first_name && item?.last_name
    ? item.first_name + ' ' + item.last_name
    : item.email

  const hasDuplicateName = items
    .filter((i) => i.id !== item.id)
    .some((b) => {
      let itemBString =
        b?.first_name && b?.last_name
          ? (b.first_name + b.last_name).toLowerCase()
          : b.username

      return fullName.toLowerCase() === itemBString
    })

  return hasDuplicateName ? `${fullName} (${item.email})` : fullName
}
